

















import { Vue, Component, Prop } from "vue-property-decorator";
import { VIPIp, db } from "@/loader";
import IpLeaf from "./IpLeaf.vue";

@Component({
	components: {
		IpLeaf,
	}
})
export default class IpTree extends Vue {
	@Prop({ type: Array, default: () => [] })
	public include!: VIPIp[];

	@Prop({ type: [Boolean, Array], default: false })
	public opened!: boolean | VIPIp[];

	public get includeWithParents(): VIPIp[] {
		// console.log(this.include);
		return this.include?.reduce?.((ips, ip) => {
			ips.push(ip);
			ips.push(...ip.parents());
			return ips;
		}, []).filter((value, index, array) => array.indexOf(value) === index) || [];
	}

	public get ips(): VIPIp[] {
		return (this.includeWithParents.length ? this.includeWithParents : db.ips.list)
			.filter(ip => !ip.fk_parent)
			.sort((a, b) => a.code.toString().localeCompare(b.code.toString()));
	}
}
